/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskCmdbConfigureObjectType from '@jira/spa-apps__servicedesk-cmdb-configure-object-type/src/ConditionalRedirectOrRouteView.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbConfigureObjectType: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskCmdbConfigureObjectType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-configure-object-type", jiraSpaEntry: "async-servicedesk-cmdb-configure-object-type" */ '@jira/spa-apps__servicedesk-cmdb-configure-object-type/src/ConditionalRedirectOrRouteView.tsx'
			),
	);

const InsightConfigureObjectType = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbConfigureObjectType}
		pageId="spa-apps/servicedesk/insight/cmdb-configure-object-type"
		shouldShowSpinner
	/>
);

export default InsightConfigureObjectType;
